<template>
  <!-- 外层容器 -->
  <div class="relative w-full h-[47.81vw] py-[3.75vw]">
    <el-image
      class="absolute top-0 left-0 w-full h-full"
      :src="backgroundImage"
      lazy
      fit="cover"
      style="object-position: center"
    ></el-image>
    <!-- 标题区域 -->
    <div
      class="relative w-full h-auto mx-auto mb-[2vw] flex flex-col justify-center gap-[0.42vw]"
    >
      <!-- 主标题框 -->
      <div class="h-[3.3vw] flex flex-col justify-center items-center">
        <div
          class="text-[2.71vw] text-[#1A2233] font-harmony font-bold leading-[3.25vw] text-center"
        >
          全国加盟计划
        </div>
      </div>
    </div>

    <!-- 容器区域 -->
    <div
      class="relative w-auto h-auto left-1/2 -translate-x-1/2 inline-flex justify-between items-center"
    >
      <!-- 光晕层 -->
      <div
        class="absolute pointer-events-none animate-glow-ring"
        :style="{
          left: '53%',
          top: '44%',
          width: '40vw',
          height: '40vw',
          transform: 'translate(-50%, -50%)',
          zIndex: 1,
        }"
      ></div>
      <!-- 图片容器 -->
      <div class="relative w-[50.36vw] h-[28.65vw]">
        <el-image
          class="w-full h-full object-cover"
          :src="`https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-study/joinus/module2/sample3.png`"
          lazy
          alt="背景图"
        />
      </div>
    </div>
    <!-- 按钮容器 -->
<!--    <el-button-->
<!--      native-type="submit"-->
<!--      class="flex mt-[2.8vw] mx-auto justify-center items-center custom-button"-->
<!--      @mouseenter="hoverButton = true"-->
<!--      @mouseleave="hoverButton = false"-->
<!--      @click="smoothScrollToBottom"-->
<!--    >-->
<!--      申请加盟-->
<!--    </el-button>-->
  </div>
</template>

  <script>
export default {
  name: "joinus-module2",
  data() {
    return {
      backgroundImage: require("@/assets/images/JoinUs/module2/sample1.png"),
    }; // 图片背景路径
  },
  methods: {
    // 平滑滚动到底部
    smoothScrollToBottom() {
      const targetScroll = document.documentElement.scrollHeight;
      const startPosition = window.scrollY || window.pageYOffset;
      const distance = targetScroll - startPosition;
      let startTime = null;

      function animation(currentTime) {
        if (!startTime) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const run = easeInOutQuad(timeElapsed, startPosition, distance, 1000);
        window.scrollTo(0, run);
        if (timeElapsed < 1000) requestAnimationFrame(animation);
      }

      function easeInOutQuad(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
      }

      requestAnimationFrame(animation);
    },
  },
};
</script>

<style scoped>
/* 自定义按钮样式 */
.custom-button {
  width: 6.87vw;
  height: 2.92vw;
  background: #f28334 !important;
  border: none;
  border-radius: 0.25vw;
  transition: all 0.3s;
}

.custom-button :deep(span) {
  color: white;
  font-size: 1.04vw;
  font-weight: bold;
  font-family: "HarmonyOS Sans SC";
}

.custom-button:hover {
  transform: scale(1.05);
  box-shadow: 0 0.2vw 0.6vw rgba(242, 131, 52, 0.5);
}

/* 添加动画样式 */
@keyframes glow-animation {
  0% {
    transform: translate(-50%, -50%) scale(0);
    opacity: 0.8;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    transform: translate(-50%, -50%) scale(1.5);
    opacity: 0;
  }
}

.animate-glow-ring {
  animation: glow-animation 3s ease-out infinite;
  background: radial-gradient(
    circle at center,
    rgba(255, 255, 255, 0.8) 0%,
    rgba(255, 255, 255, 0) 70%
  );
  border-radius: 50%;
  filter: blur(1vw);
  transform-origin: center;
}
</style>
